import {
    Box,
    DialogTitle,
    Grid,
    Modal,
    TextField,
    Divider,
} from "@mui/material";


import SearchIcon from "@mui/icons-material/Search";

import CloseIcon from "@mui/icons-material/Close";
import { useEffect, useState } from "react";

// import { getAllCustomerDetail,  } from "./api";
import { searchedElementDisplay } from "../advancePayment/receiptFunctions";

import VendorCard from "./VendorCard.jsx"
import { getVendorList } from "../vendorRegistration/vendorRegistrationCustomApiHandler";
import { getVendors } from "../vendorRegistration/vendorRegistrationApi";

const VendorSearchModal = ({
    
    searchModal = false,  // Ensure it's a boolean
    setSearchModal = () => { }, // Ensure it's a function
    cardValue = null, // Default null
    setCardValue = () => { }, // Default empty function
    // userDetail,
}) => {
    const [collection, setCollection] = useState([]);
    const [searchCurrentModal, setSearchCurrentModal] = useState("");

    const getVendorsList = async () => {
        await getVendorList(getVendors, setCollection)
    }


    useEffect(() => {
        getVendorsList()
    }, [])

    return (
      <Modal
        open={Boolean(searchModal)}
        sx={{ zIndex: 999999 }} // Yo
        onClose={() => {
          setSearchModal(false);
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Grid
          container
          sx={{
            // backgroundColor: "white",
            // width:"40%"
            background: "white",
            width: { xs: "95%", sm: "80%", md: "60%", lg: "60%", xl: "60%" },

            overflowY: "auto",
            height: "70vh",
            position: "absolute",
            left: { xs: "2%", sm: "15%", md: "25%", lg: "30%", xl: "30%" },

            top: "10%",
          }}
        >
          <Grid item xs={12}>
            <DialogTitle
              color="primary"
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                m: 0,
                pr: "10px",
                fontSize: { xs: "12px", sm: "13px", md: "15px" },
              }}
            >
              Select Vendor{" "}
              <CloseIcon
                sx={{ float: "right", cursor: "pointer" }}
                onClick={() => {
                  setSearchModal(false);
                }}
              />
            </DialogTitle>
            <Divider />
            <Box
              sx={{
                mt: 1,
                textAlign: "center",
                px: "20px",
                fontSize: { xs: "12px", sm: "13px", md: "15px" },
              }}
            >
              <TextField
                sx={{ width: "100%" }}
                size="small"
                label="Search by Name/Mobile Number"
                value={searchCurrentModal}
                onChange={(e) => {
                  setSearchCurrentModal(e.target.value);
                }}
                InputProps={{
                  endAdornment: (
                    <SearchIcon
                      sx={{
                        color: (theme) => theme.palette.primary.main,
                      }}
                    />
                  ),
                }}
                InputLabelProps={{
                  className: "mulish",
                  sx: {
                    color: "#545454",
                    fontWeight: 400,
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                    paddingX: "7px",
                  },
                }}
              />
            </Box>
            <Box sx={{ height: "55vh", overflowY: "auto", px: "20px" }}>
              {collection &&
                collection?.map((item, index) => {
                  return (
                    <VendorCard
                      key={"vendor" + index}
                      data={item}
                      callBack={(data) => {
                        setCardValue(data);
                        setSearchModal(false);
                      }}
                    />
                  );
                })}
            </Box>
          </Grid>
        </Grid>
      </Modal>
    );
};

export default VendorSearchModal;
